import type { Equipment } from '@/features/equipment/types';
import { api } from '@/lib/api';
import type {
  ExtendWarrantyPayload,
  OverrideEquipmentWarrantyPayload,
  SetVesselWarrantyPayload,
  VesselWarrantySummary,
  WarrantyExtension,
} from './types';

export const warrantyApi = {
  setVesselWarranty: async (
    vesselId: string,
    input: SetVesselWarrantyPayload,
  ): Promise<{
    vessel: {
      id: string;
      warrantyStartDate: string | null;
      warrantyEndDate: string | null;
    };
    cascadedCount: number;
  }> => {
    const { data } = await api.patch(`/vessels/${vesselId}/warranty`, input);
    return data;
  },

  vesselSummary: async (vesselId: string): Promise<VesselWarrantySummary> => {
    const { data } = await api.get<VesselWarrantySummary>(
      `/vessels/${vesselId}/warranty/summary`,
    );
    return data;
  },

  overrideEquipment: async (
    equipmentId: string,
    input: OverrideEquipmentWarrantyPayload,
  ): Promise<Equipment> => {
    const { data } = await api.patch<Equipment>(
      `/equipment/${equipmentId}/warranty/override`,
      input,
    );
    return data;
  },

  resetEquipment: async (equipmentId: string): Promise<Equipment> => {
    const { data } = await api.post<Equipment>(
      `/equipment/${equipmentId}/warranty/reset`,
    );
    return data;
  },

  extendEquipment: async (
    equipmentId: string,
    input: ExtendWarrantyPayload,
  ): Promise<{ equipment: Equipment; extension: WarrantyExtension }> => {
    const { data } = await api.post(
      `/equipment/${equipmentId}/warranty/extend`,
      input,
    );
    return data;
  },

  history: async (equipmentId: string): Promise<WarrantyExtension[]> => {
    const { data } = await api.get<WarrantyExtension[]>(
      `/equipment/${equipmentId}/warranty/history`,
    );
    return data;
  },
};
